/* import __COLOCATED_TEMPLATE__ from './node.hbs'; */
var _class, _didTeardown, _setupPromise, _element;
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { RemotePromise } from 'remote-promises';
let Node = (_class = (_didTeardown = /*#__PURE__*/new WeakMap(), _setupPromise = /*#__PURE__*/new WeakMap(), _element = /*#__PURE__*/new WeakMap(), class Node extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "children", new Set());
    _classPrivateFieldInitSpec(this, _didTeardown, false);
    _classPrivateFieldInitSpec(this, _setupPromise, new RemotePromise());
    _classPrivateFieldInitSpec(this, _element, void 0);
    if (this.args.parent) {
      // register with parent
      this.args.parent.registerChild(this);
    }
  }
  async willDestroy() {
    super.willDestroy(...arguments);
    this.willDestroyRecursive(_classPrivateFieldGet(_element, this));
  }

  /**
   * Method invoked by the child components to register themselves with their parent
   * @param {Component} child
   */
  async registerChild(child) {
    this.children.add(child);
    await _classPrivateFieldGet(_setupPromise, this);
    child.setup();
  }

  /**
   * Method invoked by the child components to unregister themselves with their parent
   * @param {Component} child
   */
  unregisterChild(child) {
    this.children.delete(child);
  }

  /**
   * method responsible for tearing down its children plus itself
   * it is called by the root initially and recursively to its children
   * @param {HTMLElement} element the root element
   */
  async willDestroyRecursive(element) {
    // this hook will be called depth-first from the top-level component
    // since we must destroy childs first, the first parent will
    // be responsible for destroying the children. `this.#didTeardown` guards
    // that we don't redestroy already destroyed children
    if (!_classPrivateFieldGet(_didTeardown, this)) {
      _classPrivateFieldSet(_didTeardown, this, true);

      // teardown children
      await Promise.all([...this.children].map(c => c.willDestroyRecursive()));
      // teardown self
      await this.teardown(element);
      if (this.args.parent) {
        this.args.parent.unregisterChild(this);
      }
    }
  }

  /**
   * method responsible for setting up itself
   * it is called by the root initially and recursively to its children
   * @param {HTMLElement} element the root element
   */
  async setup(element) {
    try {
      _classPrivateFieldSet(_element, this, element);
      // library setup code goes here
      if (typeof this.args.didInsertParent === 'function') {
        await this.args.didInsertParent(element);
      }
      if (typeof this.didInsertParent === 'function') {
        await this.didInsertParent(element);
      }
      _classPrivateFieldGet(_setupPromise, this).resolve();
    } catch (e) {
      _classPrivateFieldGet(_setupPromise, this).reject(e);
      throw e;
    }
  }

  /**
   * The actual teardown logic
   * @param {HTMLElement} element
   */
  async teardown(element) {
    // library teardown code goes here
    if (typeof this.args.willDestroyParent === 'function') {
      await this.args.willDestroyParent(element);
    }
    if (typeof this.willDestroyParent === 'function') {
      await this.willDestroyParent(element);
    }
  }
}), _applyDecoratedDescriptor(_class.prototype, "setup", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setup"), _class.prototype), _class);
export { Node as default };